// extracted by mini-css-extract-plugin
module.exports = {"prices-cell":"PricesCell_prices-cell__l317P","pending-request":"PricesCell_pending-request__id_JB","active-request":"PricesCell_active-request__2pZAw"};